<template>
  <svg
    :id="customId + '_16572699'"
    class="custom-icon"
    viewBox="0 0 90 90"
    width="90"
    height="90"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g transform="matrix(1,0,0,1,0,0)">
      <g :id="customId + '_16572699'" opacity="1" style="mix-blend-mode: normal">
        <g>
          <defs>
            <clipPath :id="customId + '_16572699_clipPath'" x="-50%" y="-50%" width="200%" height="200%">
              <path d="M0,90v-90h90v90z" fill="white" clip-rule="nonzero"></path>
            </clipPath>
          </defs>
          <g :clip-path="'url(#' + customId + '_16572699_clipPath)'">
            <g transform="matrix(1,0,0,1,0,20)">
              <g :id="customId + '_16572700'" opacity="1" style="mix-blend-mode: normal">
                <g>
                  <g>
                    <g transform="matrix(1,0,0,1,0,0)">
                      <g :id="customId + '_16572701'" opacity="1" style="mix-blend-mode: normal">
                        <g>
                          <g>
                            <path
                              :id="customId + '_16572701_fill_path'"
                              d="M20.27921,10.00697c-1.39206,0 -2.71334,0.26732 -3.96383,0.80195c-1.2269,0.51139 -2.30044,1.22036 -3.22061,2.12692c-0.92017,0.90656 -1.6516,1.97583 -2.19427,3.20781c-0.51907,1.20874 -0.7786,2.49884 -0.7786,3.87029v10.00697h21.18494l10.1573,-0.01743v19.99651h-10.1573v-10.00697h-21.18494v10.00697h-10.1219v-29.98605c0,-2.76616 0.53087,-5.35797 1.59261,-7.77545c1.06174,-2.44073 2.50098,-4.56764 4.31773,-6.38075c1.84035,-1.81311 3.98742,-3.24268 6.44122,-4.2887c2.47739,-1.04603 5.11995,-1.56904 7.92765,-1.56904h49.44158c1.86394,0 3.65711,0.24407 5.37949,0.73222c1.72237,0.4649 3.32678,1.13901 4.81322,2.02232c1.51003,0.86007 2.87849,1.90609 4.10539,3.13808c1.25049,1.20874 2.31222,2.55695 3.1852,4.04463c0.89658,1.48768 1.58082,3.07996 2.0527,4.77685c0.49548,1.69689 0.74321,3.46351 0.74321,5.29986c0,1.72013 -0.22413,3.39377 -0.67242,5.02092c-0.4247,1.62715 -1.04995,3.17294 -1.87574,4.63738c-0.8022,1.46444 -1.79316,2.81265 -2.97286,4.04463c-1.17971,1.23199 -2.50099,2.30125 -3.96383,3.20781l5.62721,13.07532h-10.79433l-4.42392,-10.07671l-12.72253,0.06974v10.00697h-10.1573v-19.99651l10.1573,0.01743h11.51922c1.39206,0 2.70154,-0.25569 3.92843,-0.76708c1.2269,-0.53464 2.30045,-1.25523 3.22062,-2.16179c0.92017,-0.90656 1.63979,-1.9642 2.15886,-3.17294c0.54267,-1.23199 0.81402,-2.5337 0.81402,-3.90516c0,-1.37146 -0.27135,-2.66155 -0.81402,-3.87029c-0.51907,-1.23199 -1.23869,-2.30126 -2.15886,-3.20781c-0.92017,-0.90656 -1.99372,-1.61553 -3.22062,-2.12692c-1.2269,-0.53464 -2.53638,-0.80195 -3.92843,-0.80195z"
                              fill-rule="nonzero"
                              fill="rgb(199, 197, 208)"
                              fill-opacity="1"
                              style="mix-blend-mode: NORMAL"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g transform="matrix(1,0,0,1,66,16.170900000000003)">
                      <g :id="customId + '_16572702'" opacity="1" style="mix-blend-mode: normal">
                        <g>
                          <g>
                            <path
                              :id="customId + '_16572702_fill_path'"
                              d="M0,3.90335c0,-2.15576 1.76288,-3.90335 3.9375,-3.90335c2.17462,0 3.9375,1.74759 3.9375,3.90335c0,2.15576 -1.76288,3.90335 -3.9375,3.90335c-2.17462,0 -3.9375,-1.74759 -3.9375,-3.90335z"
                              fill-rule="nonzero"
                              fill="rgb(233, 62, 27)"
                              fill-opacity="1"
                              style="mix-blend-mode: NORMAL"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g transform="matrix(1,0,0,1,16.5,16.170900000000003)">
                      <g :id="customId + '_16572703'" opacity="1" style="mix-blend-mode: normal">
                        <g>
                          <g>
                            <path
                              :id="customId + '_16572703_fill_path'"
                              d="M0,3.90335c0,-2.15576 1.76288,-3.90335 3.9375,-3.90335c2.17462,0 3.9375,1.74759 3.9375,3.90335c0,2.15576 -1.76288,3.90335 -3.9375,3.90335c-2.17462,0 -3.9375,-1.74759 -3.9375,-3.90335z"
                              fill-rule="nonzero"
                              fill="rgb(213, 31, 145)"
                              fill-opacity="1"
                              style="mix-blend-mode: NORMAL"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g transform="matrix(1,0,0,1,48.75,15.427500000000002)">
                      <g :id="customId + '_16572704'" opacity="1" style="mix-blend-mode: normal">
                        <g>
                          <g>
                            <path
                              :id="customId + '_16572704_fill_path'"
                              d="M0,4.64684c0,-2.56641 2.09867,-4.64689 4.6875,-4.64689c2.58883,0 4.6875,2.08048 4.6875,4.64689c0,2.56641 -2.09867,4.64689 -4.6875,4.64689c-2.58883,0 -4.6875,-2.08048 -4.6875,-4.64689z"
                              fill-rule="nonzero"
                              fill="rgb(233, 48, 86)"
                              fill-opacity="1"
                              style="mix-blend-mode: NORMAL"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g transform="matrix(1,0,0,1,32.25,15.427500000000002)">
                      <g :id="customId + '_16572705'" opacity="1" style="mix-blend-mode: normal">
                        <g>
                          <g>
                            <path
                              :id="customId + '_16572705_fill_path'"
                              d="M0,4.64684c0,-2.56638 2.09867,-4.64684 4.6875,-4.64684c2.58883,0 4.6875,2.08046 4.6875,4.64684c0,2.56638 -2.09867,4.64684 -4.6875,4.64684c-2.58883,0 -4.6875,-2.08046 -4.6875,-4.64684z"
                              fill-rule="nonzero"
                              fill="rgb(213, 31, 145)"
                              fill-opacity="1"
                              style="mix-blend-mode: NORMAL"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g transform="matrix(1,0,0,1,16.5,16.171)">
                      <g :id="customId + '_16572706'" opacity="1" style="mix-blend-mode: normal">
                        <g>
                          <g>
                            <path
                              :id="customId + '_16572706_fill_path'"
                              d="M0,3.90335c0,-2.15576 1.76288,-3.90335 3.9375,-3.90335c2.17462,0 3.9375,1.74759 3.9375,3.90335c0,2.15576 -1.76288,3.90335 -3.9375,3.90335c-2.17462,0 -3.9375,-1.74759 -3.9375,-3.90335z"
                              fill-rule="nonzero"
                              fill="rgb(177, 12, 207)"
                              fill-opacity="1"
                              style="mix-blend-mode: NORMAL"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <animateTransform
      :href="'#' + customId + '_16572702'"
      attributeName="transform"
      type="translate"
      values="3.9375 3.9034;3.9375 3.9034"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572702'"
      attributeName="transform"
      type="scale"
      values="1 1;0.6 0.6"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572702'"
      attributeName="transform"
      type="translate"
      values="-3.9375 -3.9034;-3.9375 -3.9034"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572703'"
      attributeName="transform"
      type="translate"
      values="3.9375 3.9034;3.9375 3.9034"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572703'"
      attributeName="transform"
      type="scale"
      values="0.6 0.6;1 1"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572703'"
      attributeName="transform"
      type="translate"
      values="-3.9375 -3.9034;-3.9375 -3.9034"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572704'"
      attributeName="transform"
      type="translate"
      values="0 0;16.450000000000003 0.0024999999999977263"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572704'"
      attributeName="transform"
      type="translate"
      values="4.6875 4.6469;4.6875 4.6469"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572704'"
      attributeName="transform"
      type="scale"
      values="1 1;0.84 0.84"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572704'"
      attributeName="transform"
      type="translate"
      values="-4.6875 -4.6469;-4.6875 -4.6469"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572705'"
      attributeName="transform"
      type="translate"
      values="0 0;16.549999999999997 0.0024999999999977263"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572706'"
      attributeName="transform"
      type="translate"
      values="0 0;16.5 -0.0009999999999976694"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572706'"
      attributeName="transform"
      type="translate"
      values="3.9375 3.9034;3.9375 3.9034"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572706'"
      attributeName="transform"
      type="scale"
      values="1 1;1.18 1.18"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
    <animateTransform
      :href="'#' + customId + '_16572706'"
      attributeName="transform"
      type="translate"
      values="-3.9375 -3.9034;-3.9375 -3.9034"
      dur="0.5s"
      repeatCount="indefinite"
      calcMode="spline"
      keyTimes="0;1"
      keySplines="0 0 1 1"
      additive="sum"
      fill="freeze"
    ></animateTransform>
  </svg>
</template>

<script>
export default {
  data: () => ({
    customId: Math.floor(Math.random() * 9999),
  }),

  // beforeCreate () {
  //   console.log('beforeCreate')
  //   function getRandomInt(max) {
  //     return Math.floor(Math.random() * max);
  //   }
  //   this.customId = getRandomInt(9999)
  //   console.log(this.customId)
  // },
};
</script>
